import { createSlice } from "@reduxjs/toolkit";
const widgetsSlice = createSlice({
  name: "widgets",
  initialState: {
    newWidget: void 0
  },
  reducers: {
    setNewWidget: (state, action) => ({
      ...state,
      newWidget: action.payload
    })
  }
});
export const widgetsSliceReducer = widgetsSlice.reducer;
export const setNewWidget = (id) => (dispatch) => {
  const result = dispatch(widgetsSlice.actions.setNewWidget(id));
  setTimeout(() => dispatch(widgetsSlice.actions.setNewWidget(void 0)), 1e3);
  return result;
};
export const selectNewWidget = (state) => state.widgets.newWidget;
